<template>
    <div>
      <mensajeSistema></mensajeSistema>
      <v-tabs v-model="tab" dark class="rounded-lg" dense background-color="primary" active-class="tab-active"
        slider-color="#ffbc00">
        <v-tab class="font-weight-black">Generar horario</v-tab>
        <v-tab class="font-weight-black">Horario por sección</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless @change="onTabChange">
        <v-tab-item>
          <generarhorario class="mt-2"></generarhorario>
        </v-tab-item>
        <v-tab-item>
          <horariopornivel class="mt-2" ref="horarioPorNivel"></horariopornivel>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </template>
  
  <script>
  import horariopornivel from './horariopornivel.vue';
  import generarhorario from './generarhorario.vue';
  
  export default {
    name: 'horarioAutomatico',
    components: {
      horariopornivel,
      generarhorario,
    },
    data: () => ({
      tab: 0,
    }),
    methods: {
      onTabChange(newTab) {
        if (newTab === 1) {
          this.$refs.horarioPorNivel.resetModel(); // Llama al método del componente hijo para resetear los campos
        }
      },
    },
  };
  </script>
  